import apiClient from '../axios';

function getSymptoms() {
  return apiClient.get('/symptoms');
}

export { getSymptoms };
